import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import axios from "axios";
import { useState, useEffect } from "react";
import LandingPage from "@/pages/LandingPage";
import CalculatorPage from "@/pages/CalculatorPage";
import ProjectsPage from "@/pages/ProjectsPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AdminPage from "@/pages/AdminPage";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import ProtectedRoute from "@/components/ProtectedRoute";

// Global axios config: always send cookies for auth
axios.defaults.withCredentials = true;

// Add Authorization header from localStorage as cross-domain fallback
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('session_token');
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (Google OAuth callback)
  // This must be checked synchronously during render to prevent race conditions
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route 
        path="/calculator" 
        element={
          <ProtectedRoute>
            {({ user }) => <CalculatorPage user={user} />}
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/projects" 
        element={
          <ProtectedRoute>
            {({ user }) => <ProjectsPage user={user} />}
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute>
            {() => <AdminPage />}
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
}

function App() {
  const [appVersion, setAppVersion] = useState("...");
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/app-version`)
      .then(res => setAppVersion(res.data.version))
      .catch(() => setAppVersion("1.9.0"));
  }, []);

  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <AppRouter />
        <footer className="border-t border-border py-3 text-center">
          <p className="text-xs text-muted-foreground tracking-wide">Feasibility Calculator by SM v{appVersion}</p>
        </footer>
      </BrowserRouter>
    </div>
  );
}

export default App;